import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton } from '@ui/button';
import { interpolate } from '@format/interpolate';
import { ResponsiveText } from '@web/atoms';
import { StickyNav } from '@web/molecules';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import { ButtonContainer, StyledFooter } from './styles';

export const Footer = ({
  onBackButtonClick,
  mobileCTAText = 'Continue',
  desktopCTAText = 'Continue',
  onForwardButtonClick,
  isForwardButtonDisabled,
  isBackButtonDisabled,
  isForwardButtonLoading,
}) => {
  const { formattedAmount } = useShopifyOfferContext();

  const desktopCTATextWithDiscount = interpolate(desktopCTAText, {
    discount: formattedAmount,
  });

  const mobileCTATextWithDiscount = interpolate(mobileCTAText, {
    discount: formattedAmount,
  });

  return (
    <StickyNav shown>
      <StyledFooter>
        <ButtonContainer aria-live="polite">
          {onBackButtonClick && (
            <IconButton
              aria-label="go to previous step"
              icon={{
                iconName: 'arrow-left',
                size: '24px',
                alt: 'back',
                id: 'prev_step_footer',
              }}
              onClick={onBackButtonClick}
              disabled={isBackButtonDisabled}
              type="button"
              variant="spinach"
            />
          )}
          <Button
            aria-label={mobileCTATextWithDiscount}
            disabled={isForwardButtonDisabled}
            onClick={onForwardButtonClick}
            fullWidth
            variant="spinach"
            isLoading={isForwardButtonLoading}
          >
            <ResponsiveText
              desktopText={desktopCTATextWithDiscount}
              mobileText={mobileCTATextWithDiscount}
            />
          </Button>
        </ButtonContainer>
      </StyledFooter>
    </StickyNav>
  );
};

Footer.displayName = 'OnboardingFooter';
Footer.propTypes = {
  onBackButtonClick: PropTypes.func,
  mobileCTAText: PropTypes.string,
  desktopCTAText: PropTypes.string,
  onForwardButtonClick: PropTypes.func,
  isForwardButtonDisabled: PropTypes.bool,
  isBackButtonDisabled: PropTypes.bool,
  isForwardButtonLoading: PropTypes.bool,
};
